'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, ReactNode } from 'react';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/ui/utils';
import './morfi-waitlist-button.css';
const DUST_PARTICLE_KEYS = ['dust-a', 'dust-b', 'dust-c', 'dust-d', 'dust-e', 'dust-f', 'dust-g', 'dust-h', 'dust-i', 'dust-j'] as const;
export function MorfiWaitlistButtonChrome(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span aria-hidden="true" className="morfi-waitlist-button__beam morfi-waitlist-button__beam--glow" />;
    t2 = <span aria-hidden="true" className="morfi-waitlist-button__beam" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span aria-hidden="true" className="morfi-waitlist-button__dust">{DUST_PARTICLE_KEYS.map(_temp)}</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <>{t1}{t2}{t3}<span className="morfi-waitlist-button__label">{children}</span></>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(particleKey) {
  return <span key={particleKey} className="morfi-waitlist-button__dust-particle" />;
}
interface MorfiWaitlistButtonProps {
  href: string;
  children: ReactNode;
  className?: string;
  markerHeroCta?: boolean;
}
export function MorfiWaitlistButton(t0) {
  const $ = _c(11);
  const {
    href,
    children,
    className,
    markerHeroCta: t1
  } = t0;
  const markerHeroCta = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("morfi-waitlist-button", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== markerHeroCta) {
    t3 = markerHeroCta ? {
      "data-morfi-hero-waitlist-cta": ""
    } : {};
    $[2] = markerHeroCta;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <MorfiWaitlistButtonChrome>{children}</MorfiWaitlistButtonChrome>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== href || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Link href={href} className={t2} {...t3}>{t4}</Link>;
    $[6] = href;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}